<template>
  <v-dialog v-model="dialog" max-width="900px" persistent>
    <v-card class="rounded-lg">
      <v-card-title class="pa-0">
        <v-toolbar :color="$colors[0]" class="text-white rounded-t-lg" dark elevation="0">
          <v-icon left>{{
            editedIndexProps === -1 ? "mdi-plus-circle" : "mdi-pencil"
          }}</v-icon>
          <span class="text-h6 font-weight-medium">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="mt-6">
        <v-container>
          <v-form ref="formEditCreationDialog" v-model="formValid">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  outlined
                  dense
                  :disabled="editedIndexProps !== -1"
                  v-model="editedItem.fournisseur"
                  label="Fournisseur"
                  prepend-inner-icon="mdi-office-building"
                  :rules="[(v) => !!v || 'Le fournisseur est requis']"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  outlined
                  dense
                  v-model="editedItem.assureur"
                  label="Assureur"
                  :items="['ELLIPRO', 'CREDITSAFE']"
                  prepend-inner-icon="mdi-shield"
                  :rules="[(v) => !!v || 'L\'assureur est requis']"
                  class="rounded-lg"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="editedItem.score"
                  label="Score"
                  prepend-inner-icon="mdi-star"
                  ref="ScoreField"
                  :rules="scoreRules"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                      outlined
                      dense
                      v-model="formattedDateDebutMin"
                      label="Début (min)"
                      prepend-inner-icon="mdi-calendar-start"
                      :rules="[validateDateMin(editedItem.date_debut_min,editedItem.date_debut_max,'date')]"
                      class="rounded-lg"
                    >
                    </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                      outlined
                      dense
                      v-model="formattedDateDebutMax"
                      ref="DateDebutMaxField"
                      label="Début (max)"
                      prepend-inner-icon="mdi-calendar-start"
                      :rules="[validateDateMax(editedItem.date_debut_min,editedItem.date_debut_max,'date')]"
                      class="rounded-lg"
                    ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                      outlined
                      dense
                      v-model="formattedDateFinMin"
                      ref="DateFinMinField"
                      label="Fin (min)"
                      prepend-inner-icon="mdi-calendar-end"
                      :rules="[validateDateMin(editedItem.date_fin_min,editedItem.date_fin_max,'date')]"
                      class="rounded-lg"
                    ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                      outlined
                      dense
                      v-model="formattedDateFinMax"
                      label="Fin (max)"
                      ref="DateFinMaxField"
                      prepend-inner-icon="mdi-calendar-end"
                      :rules="[validateDateMax(editedItem.date_fin_min,editedItem.date_fin_max,'date')]"
                      class="rounded-lg"
                    ></v-text-field>
              </v-col>
              <!-- Nouveaux champs pour les marges et consommations -->
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="editedItem.min_marge"
                  ref="MargeField"
                  label="Marge minimum (€)"
                  prepend-inner-icon="mdi-currency-eur"
                  :rules="[validateConsumptionMax(editedItem.min_marge,editedItem.max_marge,'marge')]"
                  suffix="€"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="editedItem.max_marge"
                  label="Marge maximum (€)"
                  prepend-inner-icon="mdi-currency-eur"
                  :rules="[validateConsumptionMax(editedItem.min_marge,editedItem.max_marge,'marge')]"
                  suffix="€"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  ref="ConsoField"
                  v-model="editedItem.min_conso"
                  label="Consommation minimum (KWh)"
                  prepend-inner-icon="mdi-flash"
                  :rules="[validateConsumptionMin(editedItem.min_conso,editedItem.max_conso,'consommation')]"
                  suffix="KWh"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="editedItem.max_conso"
                  label="Consommation maximum (KWh)"
                  prepend-inner-icon="mdi-flash"
                  :rules="[validateConsumptionMax(editedItem.min_conso,editedItem.max_conso,'consommation')]"
                  suffix="KWh"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  type="number"
                  outlined
                  dense
                  v-model="editedItem.consoEte"
                  label="Consommation Été (KWh)"
                  prepend-inner-icon="mdi-flash"
                  :rules="[
                    (v) => v != undefined || 'La consommation Été est requise',
                    (v) => v >= 0 || 'La consommation doit être supérieure ou égale à 0',
                  ]"
                  suffix="KWh"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-card class="rounded-lg" outlined>
                  <v-card-text class="pa-0">
                    <div class="d-flex align-center px-3 pt-3">
                      <v-icon class="mr-2">mdi-tag-multiple</v-icon>
                      <div class="text-subtitle-2">NAF</div>
                    </div>
                    
                    <div class="px-3 py-2 input-chips-container" style="min-height: 100px; max-height: 200px;">
                      <!-- Zone de défilement pour les chips (sauf le dernier et l'input) -->
                      <div class="chip-scroll-container" style="max-height: 120px; overflow-y: auto; margin-bottom: 8px;">
                        <div class="d-flex flex-wrap">
                          <v-chip
                            v-for="(item, index) in chipsToScroll"
                            :key="index"
                            small
                            pill
                            class="ma-1"
                            close
                            @click:close="removeItem(index)"
                          >
                            <span>{{ item }}</span>
                          </v-chip>
                        </div>
                      </div>
                      
                      <!-- Zone fixe pour le dernier chip et l'input (toujours visible) -->
                      <div class="d-flex flex-wrap align-center fixed-input-area">
                        <v-chip
                          v-if="lastChip"
                          small
                          pill
                          class="ma-1"
                          close
                          @click:close="removeItem(editedItem.codeNaf.length - 1)"
                        >
                          <span>{{ lastChip }}</span>
                        </v-chip>
                        <v-chip small class="mr-2" v-if="editedItem.codeNaf.length > 0">
                          {{ editedItem.codeNaf.length }} sélectionné(s)
                        </v-chip>
                        
                        <!-- Input pour ajouter de nouveaux éléments -->
                        <input
                          ref="chipInput"
                          v-model="newItem"
                          placeholder="Ajouter un code NAF..."
                          class="chip-input ml-1 my-1"
                          @keydown.enter.prevent="addItem"
                          @keydown.tab.prevent="addItem"
                          @keydown.comma.prevent="addItem"
                          style="border: none; outline: none; min-width: 150px; flex-grow: 1;"
                        />
                      </div>
                    </div>
                    
                    <!-- Suggestions/auto-complétion -->
                    <v-expand-transition>
                      <div v-if="filteredSuggestions.length && newItem" class="px-2 pb-2">
                        <v-list dense class="suggestion-list py-0">
                          <v-list-item
                            v-for="(suggestion, index) in filteredSuggestions"
                            :key="index"
                            dense
                            @click="selectSuggestion(suggestion)"
                            class="suggestion-item py-1"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ suggestion }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-expand-transition>
                  </v-card-text>
                  
                  <v-divider></v-divider>
                  
                  <!-- Actions en bas -->
                  <v-card-actions class="py-1 px-2">
                    <v-spacer></v-spacer>
                    <v-btn
                      x-small
                      text
                      color="primary"
                      @click="selectAll"
                    >
                      Tout sélectionner
                    </v-btn>
                    <v-btn
                      x-small
                      text
                      color="error"
                      @click="clearAll"
                    >
                      Effacer tout
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="error" outlined rounded class="px-6" @click="close">
          <v-icon left>mdi-close</v-icon> Annuler
        </v-btn>
        <v-btn
          :color="$colors[0]"
          rounded
          :disabled="!formValid"
          class="px-6 white--text"
          @click="save"
        >
          <v-icon color="white" left>mdi-content-save</v-icon> Enregistrer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  props: {
    dialogProps: Boolean,
    editedIndexProps: Number,
    editedItemProps: Object,
    listNafItemActuelProps: Array,
  },
  data() {
    return {
      newItem: '',
      regexDate:/^\d{4}-\d{2}-\d{2}$/,
      regexMois: /^M\+\d+$/,
      regexJours: /^J\+\d+$/,
      formValid: false,
      dateDebutMinMenu: false,
      dateDebutMaxMenu: false,
      dateFinMinMenu: false,
      dateFinMaxMenu: false,
      dialog: false,
      editedItem: {
        fournisseur: "",
        assureur: "",
        date_debut_min: "",
        date_debut_max: "",
        date_fin_min: "",
        date_fin_max: "",
        score: "",
        codeNaf: "",
        consoEte: 0,
        min_marge: 0,
        max_marge: 0,
        min_conso: 0,
        max_conso: 0,
      },
      listNafItemActuel: [],
    };
  },
  watch: {
    "editedItem.assureur": {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.ScoreField) {
            this.$refs.ScoreField.validate();
          }
        });
      },
    },
    "editedItem.max_marge": {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.MargeField) {
            this.$refs.MargeField.validate();
          }
        });
      },
    },
    "editedItem.max_conso": {
      handler(newValue) {
        console.log(newValue)
        this.$nextTick(() => {
          if (this.$refs.ConsoField) {
            this.$refs.ConsoField.validate();
          }
        });
      },
    },
    "editedItem.date_debut_max": {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.DateFinMinField && !!this.editedItem.date_fin_min) {
            this.$refs.DateFinMinField.validate();
          }
        });
      },
    },
    "editedItem.date_fin_min": {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.DateFinMaxField && !!this.editedItem.date_fin_max) {
            this.$refs.DateFinMaxField.validate();
          }
        });
      },
    },
    "editedItem.date_debut_min": {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.DateDebutMaxField && !!this.editedItem.date_debut_max) {
            this.$refs.DateDebutMaxField.validate();
          }
        });
      },
    },
    dialogProps: function (newVal) {
      this.dialog = newVal;
    },
    editedItemProps: {
      handler(newVal) {
        this.editedItem = newVal;
      },
      deep: true,
    },
    listNafItemActuelProps: function (newVal) {
      this.listNafItemActuel = newVal;
    },
  },
  computed: {
    formattedDateDebutMin: {
      get() {
        const date = this.editedItem.date_debut_min;
        // Vérifie si la date est sous le format "aaaa-mm-jj" et la convertit en "jj/mm/aaaa"
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
          return this.formatDateToDDMMYYYY(date);
        }
        return date; // Retourne la valeur brute si ce n'est pas une date
      },
      set(value) {
        // Si l'utilisateur entre une date en "jj/mm/aaaa", on la reformate en "aaaa-mm-jj"
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          const [day, month, year] = value.split("/");
          this.editedItem.date_debut_min = `${year}-${month}-${day}`;
        } else {
          this.editedItem.date_debut_min = value; // Garde tel quel pour M+X et J+X
        }
      },
    },
    formattedDateDebutMax: {
      get() {
        const date = this.editedItem.date_debut_max;
        // Vérifie si la date est sous le format "aaaa-mm-jj" et la convertit en "jj/mm/aaaa"
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
          return this.formatDateToDDMMYYYY(date);
        }
        return date; // Retourne la valeur brute si ce n'est pas une date
      },
      set(value) {
        // Si l'utilisateur entre une date en "jj/mm/aaaa", on la reformate en "aaaa-mm-jj"
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          const [day, month, year] = value.split("/");
          this.editedItem.date_debut_max = `${year}-${month}-${day}`;
        } else {
          this.editedItem.date_debut_max = value; // Garde tel quel pour M+X et J+X
        }
      },
    },
    formattedDateFinMin: {
      get() {
        const date = this.editedItem.date_fin_min;
        // Vérifie si la date est sous le format "aaaa-mm-jj" et la convertit en "jj/mm/aaaa"
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
          return this.formatDateToDDMMYYYY(date);
        }
        return date; // Retourne la valeur brute si ce n'est pas une date
      },
      set(value) {
        // Si l'utilisateur entre une date en "jj/mm/aaaa", on la reformate en "aaaa-mm-jj"
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          const [day, month, year] = value.split("/");
          this.editedItem.date_fin_min = `${year}-${month}-${day}`;
        } else {
          this.editedItem.date_fin_min = value; // Garde tel quel pour M+X et J+X
        }
      },
    },
    formattedDateFinMax: {
      get() {
        const date = this.editedItem.date_fin_max;
        // Vérifie si la date est sous le format "aaaa-mm-jj" et la convertit en "jj/mm/aaaa"
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
          return this.formatDateToDDMMYYYY(date);
        }
        return date; // Retourne la valeur brute si ce n'est pas une date
      },
      set(value) {
        // Si l'utilisateur entre une date en "jj/mm/aaaa", on la reformate en "aaaa-mm-jj"
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          const [day, month, year] = value.split("/");
          this.editedItem.date_fin_max = `${year}-${month}-${day}`;
        } else {
          this.editedItem.date_fin_max = value; // Garde tel quel pour M+X et J+X
        }
      },
    },
    formTitle() {
      return this.editedIndexProps === -1
        ? "Nouveau Fournisseur"
        : "Modification Fournisseur";
    },
    AllSelectedNAF() {
      return this.editedItem.codeNaf?.length === this.listNafItemActuel.length;
    },
    icon() {
      if (this.AllSelectedNAF) return "mdi-checkbox-marked";
      return "mdi-checkbox-blank-outline";
    },
    chipsToScroll() {
    return this.editedItem.codeNaf.length > 1 
      ? this.editedItem.codeNaf.slice(0, -1) 
      : [];
  },
  // Le dernier chip reste toujours visible avec l'input
  lastChip() {
    return this.editedItem.codeNaf.length > 0 
      ? this.editedItem.codeNaf[this.editedItem.codeNaf.length - 1] 
      : null;
  },
  filteredSuggestions() {
    if (!this.newItem) return [];
    return this.listNafItemActuel.filter(item => 
      item.toLowerCase().includes(this.newItem.toLowerCase()) && 
      !this.editedItem.codeNaf.includes(item)
    ).slice(0, 5); // Limite à 5 suggestions
  },
    maxScore() {
      return this.editedItem.assureur === "CREDITSAFE" ? 100 : 10;
    },
    scoreRules() {
      let value = this.maxScore;
      console.log(`Le score doit être entre 0 et ${value}`);
      return [
        (v) => !!v || "Le score est requis",
        (v) => (v && v >= 0 && v <= value) || `Le score doit être entre 0 et ${value}`,
      ];
    },
  },
  methods: {
    addItem() {
    if (!this.newItem.trim()) return;
    
    // Vérifie si l'élément existe dans la liste
    const existingItem = this.listNafItemActuel.find(
      item => item.toLowerCase() === this.newItem.toLowerCase()
    );
    
    if (existingItem && !this.editedItem.codeNaf.includes(existingItem)) {
      this.editedItem.codeNaf.push(existingItem);
    } else if (!this.listNafItemActuel.includes(this.newItem) && 
               !this.editedItem.codeNaf.includes(this.newItem)) {
      // Ajout d'un nouvel élément personnalisé
      this.editedItem.codeNaf.push(this.newItem);
    }
    
    this.newItem = '';
    this.$nextTick(() => {
      this.$refs.chipInput.focus();
      // Faire défiler vers le bas si nécessaire
      const scrollContainer = document.querySelector('.chip-scroll-container');
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    });
  },
  removeItem(index) {
    this.editedItem.codeNaf.splice(index, 1);
  },
  selectSuggestion(suggestion) {
    if (!this.editedItem.codeNaf.includes(suggestion)) {
      this.editedItem.codeNaf.push(suggestion);
    }
    this.newItem = '';
    this.$nextTick(() => {
      this.$refs.chipInput.focus();
    });
  },
  selectAll() {
    if (this.editedItem.codeNaf.length === this.listNafItemActuel.length) {
      this.editedItem.codeNaf = [];
    } else {
      this.editedItem.codeNaf = [...this.listNafItemActuel];
    }
  },
  clearAll() {
    this.editedItem.codeNaf = [];
  },
    formatDateToDDMMYYYY(dateStr) {
      const [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    },

  convertToDate(str, refDate = new Date()) {
    if (this.regexDate.test(str)) {
      // Format dd/mm/yyyy
      const [year, month, day] = str.split('-').map(Number);
      return new Date(year, month - 1, day);
    } 
    if (this.regexMois.test(str)) {
      // Format M+nombre (ajoute des mois à la date actuelle)
      const monthsToAdd = parseInt(str.slice(1), 10);
      const newDate = new Date(refDate);
      newDate.setMonth(newDate.getMonth() + monthsToAdd);
      return newDate;
    } 
    if (this.regexJours.test(str)) {
      // Format J+nombre (ajoute des jours à la date actuelle)
      const daysToAdd = parseInt(str.slice(1), 10);
      const newDate = new Date(refDate);
      newDate.setDate(newDate.getDate() + daysToAdd);
      return newDate;
    }
    return null; // Format invalide
  },
    validateDateMin(min, max,theme) {
      const minDate = this.convertToDate(min);
      const maxDate = this.convertToDate(max);
      if (minDate === undefined) {
        return `La ${theme} minimum est requise`;
      }
      if (minDate < 0) {
        return `La ${theme} doit être supérieure ou égale à 0`;
      }
      if (maxDate !== undefined && minDate > maxDate) {
        return `La ${theme} minimum doit être inférieure à la ${theme} maximum`;
      }
      
      return true;
    },
    validateDateMax(min,max,theme){
      const minDate = this.convertToDate(min);
      const maxDate = this.convertToDate(max);
      if (maxDate === undefined) {
        return `La ${theme} maximum est requise`;
      }
      
      if (maxDate < 0) {
        return `La ${theme} doit être supérieure ou égale à 0`;
      }
      if (maxDate !== undefined && minDate > maxDate) {
        return `La ${theme} maximum doit être supérieure à la ${theme} inférieur`;
      }
      return true;
    },
    validateConsumptionMin(min, max,theme) {
      if (min === undefined) {
        return `La ${theme} minimum est requise`;
      }
      if (min < 0) {
        return `La ${theme} doit être supérieure ou égale à 0`;
      }
      if (max !== undefined && Number(min) > Number(max)) {
        return `La ${theme} minimum doit être inférieure à la ${theme} maximum`;
      }
      
      return true;
    },
    validateConsumptionMax(min,max,theme){
      if (max === undefined) {
        return `La ${theme} maximum est requise`;
      }
      
      if (max < 0) {
        return `La ${theme} doit être supérieure ou égale à 0`;
      }
      
      if (max !== undefined && Number(min) > Number(max)) {
        return `La ${theme} maximum doit être supérieure à la ${theme} inférieur`;
      }
      return true;
    },
    close() {
      this.dialog = false;
      this.$emit("closeDialog", this.dialog);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
      this.$refs.formEditCreationDialog.resetValidation();
    },
    async save() {
      if (this.$refs.formEditCreationDialog.validate()) {
        if (this.editedIndexProps > -1) {
          if (this.editedItem.codeNaf !== "," && this.editedItem.codeNaf?.length > 0) {
            this.editedItem.codeNaf = this.editedItem.codeNaf.join(",");
          } else {
            this.editedItem.codeNaf = "";
          }
          await axios({
            url: process.env.VUE_APP_URL_API_ADMIN + "updateAssureurDatatable/",
            method: "POST",
            data: {
              updateAssureur: this.editedItem,
              token: this.getToken("dash_token"),
            },
          }).then((res) => {
            if (res.data.resultat.result == true) {
              this.$emit("modificationData", res.data.resultat.data);
            }
          });
        } else {
          if (this.editedItem.codeNaf !== "," && this.editedItem.codeNaf?.length > 0) {
            this.editedItem.codeNaf = this.editedItem.codeNaf.join(",");
          } else {
            this.editedItem.codeNaf = "";
          }

          await axios({
            url: process.env.VUE_APP_URL_API_ADMIN + "createAssureurDatatable/",
            method: "POST",
            data: {
              newAssureur: this.editedItem,
              token: this.getToken("dash_token"),
            },
          }).then((res) => {
            if (res.data.resultat.result == true) {
              this.$emit("creationData", res.data.resultat.data);
            }
          });
        }
      }
      this.$refs.formEditCreationDialog.resetValidation();
      this.close();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.AllSelectedNAF) {
          this.editedItem.codeNaf = [];
        } else {
          this.editedItem.codeNaf = this.listNafItemActuel.slice();
        }
      });
    },
  },
};
</script>
<style scoped>
.input-chips-container {
  border-radius: 4px;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}


.chip-scroll-container {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  padding-bottom: 4px;
}

.fixed-input-area {
  min-height: 36px;
  padding-top: 4px;
}

.suggestion-list {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.suggestion-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
